var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoArrowRightSettings = function SvgIcoArrowRightSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 18,
    fill: "none",
    viewBox: "0 0 9 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M8.605 8.191a1 1 0 0 0-.06-.078l-5.78-6.767A1.05 1.05 0 0 0 1.168 2.71L6.56 9.023l-5.448 6.379a1.05 1.05 0 0 0 1.597 1.363l6.04-7.071a1.05 1.05 0 0 0-.144-1.503",
    clipRule: "evenodd"
  })));
};
export default SvgIcoArrowRightSettings;